import React from 'react';
import { faqData } from '../../data/faqData'; // Assuming you have a data file for FAQs

class Faq extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-left">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Some</span> FAQ</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            <div className="section-content p-b30">
                                <div className="mt-accordion acc-bg-gray" id="accordion5">
                                    {faqData.map((faq, index) => {
                                        return (
                                            <div key={index} className="panel mt-panel">
                                                <div className="acod-head">
                                                    <h6 className="acod-title">
                                                        <a data-toggle="collapse" href={`#collapse_${index}_5`} className="collapsed" data-parent="#accordion5">
                                                            {faq.question}
                          <span className="indicator"><i className="fa" /></span>
                                                        </a>
                                                    </h6>
                                                </div>
                                                <div id={`collapse_${index}_5`} className="acod-body collapse">
                                                    <div className="acod-content p-tb15">{faq.answer}</div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* FAQ */}
                </div>
            </>
        );
    }
};

export default Faq;